<template>
  <div class="edit-link">
    <EditLink/>
  </div>
</template>

<script>
// @ is an alias to /src
import EditLink from '@/components/EditLink.vue'

export default {
  name: 'EditLinkPage',
  components: {
    EditLink
  }
}
</script>
